import React, { useCallback } from "react";
import styles from "./index.module.scss";
import { PointsActivityItem } from "../PointsActivity";
import dayjs from "dayjs";
import { availableGiftCards, SOURCE_TYPES } from "../../../../constants";

// 表格头部组件
export const DesktopTableHeader: React.FC = () => (
  <div className={styles.tableHeader}>
    <div className={styles.detailsColumn}>Details</div>
    <div className={styles.dateColumn}>Date</div>
    <div className={styles.pointsColumn}>Points</div>
  </div>
);

// 桌面版积分活动项组件
export const DesktopActivityItem: React.FC<{
  activity: PointsActivityItem;
}> = ({ activity }) => {
  const getActivityName = useCallback(() => {
    if (activity.change_amount > 0 && !activity.order_name) {
      return "Manual Points Grant";
    }

    if (activity.change_amount < 0 && !activity.order_name) {
      const card = availableGiftCards.find(
        (card) => card.points === Math.abs(activity.change_amount)
      );
      return `Redeemed: ${card?.amount} Gift Card`;
    }
  }, [activity]);

  return !activity.order_name &&
    activity.source_type === SOURCE_TYPES.REFUND ? null : (
    <div className={styles.desktopActivityItem}>
      <div className={styles.detailsColumn}>
        {activity.order_name || getActivityName()}
      </div>
      <div className={styles.dateColumn}>
        {dayjs(activity.create_time).format("YYYY-MM-DD")}
      </div>
      <div
        className={`${styles.pointsColumn} ${
          activity.change_amount > 0 ? styles.positive : styles.negative
        }`}
      >
        {activity.change_amount > 0
          ? `+${activity.change_amount}`
          : activity.change_amount}
        {/* {activity.source_type === SOURCE_TYPES.REFUND && (
          <span className={styles.refundedTag}>Refunded</span>
        )} */}
        {activity.type === 1 && (
          <span className={styles.pendingTag}>Expected Soon</span>
        )}
      </div>
    </div>
  );
};

// 桌面版积分活动列表组件
interface DesktopPointsActivityProps {
  activities: PointsActivityItem[];
  showEmptyState?: boolean;
  emptyComponent?: React.ReactNode;
  filter?: (item: PointsActivityItem) => boolean;
  showNoticeTips?: boolean;
}

const DesktopPointsActivity: React.FC<DesktopPointsActivityProps> = ({
  activities,
  showEmptyState = true,
  emptyComponent,
  filter,
  showNoticeTips = true,
}) => {
  const filteredActivities = filter ? activities.filter(filter) : activities;

  return (
    <div className={styles.desktopContent}>
      {showNoticeTips && (
        <div className={styles.noticeText}>
          *Points will be available when your order is delivered.
        </div>
      )}
      <DesktopTableHeader />
      <div className={styles.desktopActivitiesList}>
        {filteredActivities.length > 0
          ? filteredActivities.map((activity, idx) => (
              <DesktopActivityItem key={idx} activity={activity} />
            ))
          : showEmptyState && emptyComponent}
      </div>
    </div>
  );
};

export default DesktopPointsActivity;
